import { defineStore } from 'pinia'
import { actions, getters, state } from './ext/items.js'
import axios from 'axios'


export const useDonationsStore = defineStore('donations', {
  id: 'donation',
  state: () => ({
    items: [],
    api: '/api/v1/donations'
  }),
  getters: {
    itemsByFundraiserId: (state) => (fundraiserId) => {
      return state.items.filter(item => item.fundraiser_id === fundraiserId)
    },
    ...getters
  },
  actions: {
    async fetchItemsByFundraiserId(fundraiserId) {
      const { data } = await axios.get(`${this.api}`, {
        params: {
          fundraiser_id: fundraiserId,
          not_paginated: true
        }
      })
      this.items = data.data
      return data
    },
    async generateCsvExport(params) {
      const { data } = await axios.post(`${this.api}/export`, params)
      return data
    },
    async reassignDonationToFundraiserPage(donationId, fundraiserPageId) {
      const { data } = await axios.post(`${this.api}/${donationId}/reassign-to-fundraiser-page`, { fundraiser_page_id: fundraiserPageId })
      this.itemPatchState(data)
      return data
    },
    async rebuildCache(donationId) {
      const { data } = await axios.post(`${this.api}/${donationId}/rebuild-cache`)
      this.itemPatchState(data)
      return data
    },
    async refund(donationId) {
      const { data } = await axios.post(`${this.api}/${donationId}/refund`)
      this.itemPatchState(data)
      return data
    },
    ...actions
  }
})
